module.exports = __webpack_public_path__ + "static/img/weifang.22a30d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/weifang.png
// module id = 2UHA
// module chunks = 93